import axios from "axios"
//存放所有静态图层数据的地方。


class StaticData {
    constructor() {
        this.datastore = {}
    }
    loadDataFromBufferToJson(buffer) {
        return new Promise((resolve) => {
            let reader = new FileReader();
            reader.readAsArrayBuffer(buffer);
            reader.onload = function (e) {
                shp(this.result)
                    .then((data) => {
                        resolve(data)
                    }).catch(error => {
                        console.log("数据转换错误", error);
                        reject(error)
                    });
            }
        })
    }
    loadDataToJson(buffer) {
        return new Promise((resolve) => {
            resolve(buffer)
        })
    }
    _getJsonData(urls = [], responseType = 'json') {
        return new Promise((resolve) => {
            let request = []
            let promises = []
            for (let i = 0; i <= urls.length - 1; i++) {
                if (this.datastore[urls[i]]) {
                    promises.push(this.loadDataToJson(this.datastore[urls[i]]))
                } else {
                    request.push(axios.get(urls[i], { responseType: responseType }))
                }
            }
            if (request.length > 0) {
                axios.all(request).then((res) => {
                    for (let i = 0; i <= res.length - 1; i++) {
                        const buffer = res[i].data
                        const url = res[i].config.url
                        if (!this.datastore[url]) {
                            this.datastore[url] = buffer
                        }
                        promises.push(this.loadDataToJson(buffer))
                    }
                    Promise.all(promises).then((msg) => {
                        resolve(msg)
                    })
                }).catch(error => {
                    console.log("login failed", error);
                });
            } else {
                Promise.all(promises).then((msg) => {
                    resolve(msg)
                })
            }
        })
    }
    _getBlobData(urls = [], responseType = 'blob') {
        return new Promise((resolve) => {
            let request = []
            let promises = []
            for (let i = 0; i <= urls.length - 1; i++) {
                if (this.datastore[urls[i]]) {
                    promises.push(this.loadDataFromBufferToJson(this.datastore[urls[i]]))
                } else {
                    request.push(axios.get(urls[i], { responseType: responseType }))
                }
            }
            if (request.length > 0) {
                axios.all(request).then((res) => {
                    let promises = []
                    for (let i = 0; i <= res.length - 1; i++) {
                        const buffer = res[i].data
                        const url = res[i].config.url
                        if (!this.datastore[url]) {
                            this.datastore[url] = buffer
                        }
                        promises.push(this.loadDataFromBufferToJson(buffer))
                    }
                    Promise.all(promises).then((msg) => {
                        resolve(msg)
                    })
                }).catch(error => {
                    console.log("login failed", error);
                });
            } else {
                Promise.all(promises).then((msg) => {
                    resolve(msg)
                })
            }

        })
    }
}

export default new StaticData()


// WEBPACK FOOTER //
// ./src/data/staticData.js